import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import CategoryBar from "@/components/CategoryBar";
import BottomNav from "@/components/BottomNav";
import AIChat from "@/components/AIChat";
import Home from "@/pages/Home";
import Listings from "@/pages/Listings";
import PropertyDetail from "@/pages/PropertyDetail";
import PostProperty from "@/pages/PostProperty";
import Dashboard from "@/pages/Dashboard";
import Motors from "@/pages/Motors";
import DiscoverSwipe from "@/pages/DiscoverSwipe";
import Chats from "@/pages/Chats";
import Premium from "@/pages/Premium";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import CarDetail from "@/pages/CarDetail";
import PostVehicle from "@/pages/PostVehicle";
import ComingSoon from "@/pages/ComingSoon";
import VerticalListings from "@/pages/VerticalListings";
import VerticalDetail from "@/pages/VerticalDetail";
import PostListing from "@/pages/PostListing";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Navbar />
      <CategoryBar />
      <div className="pb-16 md:pb-0">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/properties" element={<Listings />} />
          <Route path="/properties/:id" element={<PropertyDetail />} />
          <Route path="/motors" element={<Motors />} />
          <Route path="/discover" element={<DiscoverSwipe />} />
          <Route path="/chats" element={<Chats />} />
          <Route path="/chats/:id" element={<Chats />} />
          <Route path="/premium" element={<Premium />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/motors/post" element={<PostVehicle />} />
          <Route path="/motors/:id" element={<CarDetail />} />
          <Route path="/post" element={<PostProperty />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/v/:vertical/post" element={<PostListing />} />
          <Route path="/v/:vertical/:id" element={<VerticalDetail />} />
          <Route path="/v/:vertical" element={<VerticalListings />} />
          <Route path="/vertical/:slug" element={<ComingSoon />} />
        </Routes>
      </div>
      <AIChat />
      <BottomNav />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
